/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceOperationVM { 
    id?: number;
    deviceId?: number;
    notes?: string | null;
    opType?: string | null;
    createdAt?: string;
    createdBy?: number;
    createdByName?: string | null;
}

